module.exports = __webpack_public_path__ + "static/media/foodo6.6edfd0e7.png";